export default {
  actions: {
    loadPrintLabelInfo: 'LOAD_PRINT_LABEL_INFO',
  },
  mutations: {
    setPrintLabelInfo: 'SET_PRINT_LABEL_INFO',
    setLoading: 'SET_PL_LOADING',
    setError: 'SET_ERROR',
  },
  getters: {
    getPrintLabelInfo: 'GET_PRINT_LABEL_INFO',
    isLoading: 'IS_PL_LOADING',
    getError: 'GET_ERROR',
  },
};
